export default __webpack_public_path__ + "static/media/005-cone.b3a9a449.png";